import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import AdminLayout from './AdminPanel/AdminLayout';

const PrivateRoute = ({ component: Component, auth, ...rest }: any) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated === true && auth.user.isAdmin === true ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

const mapStateToProps = (state: any) => ({
  auth: state.form,
});

export default connect(mapStateToProps)(PrivateRoute);
